var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  AbortError: () => import_AbortError.AbortError,
  RestError: () => import_restError.RestError,
  TypeSpecRuntimeLogger: () => import_logger.TypeSpecRuntimeLogger,
  createClientLogger: () => import_logger.createClientLogger,
  createDefaultHttpClient: () => import_defaultHttpClient.createDefaultHttpClient,
  createEmptyPipeline: () => import_pipeline.createEmptyPipeline,
  createHttpHeaders: () => import_httpHeaders.createHttpHeaders,
  createPipelineRequest: () => import_pipelineRequest.createPipelineRequest,
  createRestError: () => import_restError2.createRestError,
  getClient: () => import_getClient.getClient,
  getLogLevel: () => import_logger.getLogLevel,
  isRestError: () => import_restError.isRestError,
  operationOptionsToRequestParameters: () => import_operationOptionHelpers.operationOptionsToRequestParameters,
  setLogLevel: () => import_logger.setLogLevel,
  stringToUint8Array: () => import_bytesEncoding.stringToUint8Array,
  uint8ArrayToString: () => import_bytesEncoding.uint8ArrayToString
});
module.exports = __toCommonJS(src_exports);
var import_AbortError = require("./abort-controller/AbortError.js");
var import_logger = require("./logger/logger.js");
var import_httpHeaders = require("./httpHeaders.js");
var import_pipelineRequest = require("./pipelineRequest.js");
var import_pipeline = require("./pipeline.js");
var import_restError = require("./restError.js");
var import_bytesEncoding = require("./util/bytesEncoding.js");
var import_defaultHttpClient = require("./defaultHttpClient.js");
var import_getClient = require("./client/getClient.js");
var import_operationOptionHelpers = require("./client/operationOptionHelpers.js");
var import_restError2 = require("./client/restError.js");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AbortError,
  RestError,
  TypeSpecRuntimeLogger,
  createClientLogger,
  createDefaultHttpClient,
  createEmptyPipeline,
  createHttpHeaders,
  createPipelineRequest,
  createRestError,
  getClient,
  getLogLevel,
  isRestError,
  operationOptionsToRequestParameters,
  setLogLevel,
  stringToUint8Array,
  uint8ArrayToString
});
